import { render, staticRenderFns } from "./AssetTypeList.vue?vue&type=template&id=9fad0938&scoped=true&"
import script from "./AssetTypeList.vue?vue&type=script&lang=js&"
export * from "./AssetTypeList.vue?vue&type=script&lang=js&"
import style0 from "./AssetTypeList.vue?vue&type=style&index=0&id=9fad0938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fad0938",
  null
  
)

export default component.exports